import React from 'react';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import LeadCatcherNewForm from 'components/forms/leads/LeadCatcherNewForm';

class LeadCatcherNew extends React.Component {
  render() {
    const { intl, show, close, onSubmitParent } = this.props;
    const messages = intl.messages;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_lead_catcher}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LeadCatcherNewForm onSubmitParent={onSubmitParent} />
        </Modal.Body>
      </Modal>
    );
  }
}

export default injectIntl(LeadCatcherNew);
